<style lang="scss" scoped>
  .btn-lg,
  .btn-group-lg > .btn {
    font-size: 1rem;
    min-width: 2.75rem;
    font-weight: 400;
  }

  .loader {
    height: 264px;
  }

  .loader-middle {
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
  }

  .loader-ring {
    display: inline-block;
    position: relative;
    width: 64px;
    height: 64px;
  }

  .loader-ring div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 51px;
    height: 51px;
    margin: 6px;
    border: 4px solid #27ae60;
    border-radius: 50%;
    animation: loader-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: #27ae60 transparent transparent transparent;
  }

  .loader-ring div:nth-child(1) {
    animation-delay: -0.45s;
  }

  .loader-ring div:nth-child(2) {
    animation-delay: -0.3s;
  }

  .loader-ring div:nth-child(3) {
    animation-delay: -0.15s;
  }

  @keyframes loader-ring {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }
</style>

<template>
  <div
    class="card"
    v-if="device"
  >
    <div class="card-header">
      {{ __('Autorizar Dispositivo') }}
      <a
        class="float-right"
        @click.prevent="cancel()"
        v-if="! scanning"
      >
        <i class="fa fa-times" />
      </a>
      <div
        class="float-right"
        v-else-if="loading"
      >
        <i class="fa fa-circle-o-notch fa-spin" />
      </div>
    </div>

    <div class="card-body">
      <div class="col-sm-12 col-md-12">
        <div class="my-3 my-md-4">
          <div
            class="text-center"
            v-if="scanning"
          >
            <div v-if="loading">
              <h3>{{ __('Criando sessão... isso pode levar vários minutos') }}.</h3>
              <hr class="w-50">
              <div class="loader">
                <div class="loader-middle">
                  <div class="loader-ring">
                    <div />
                    <div />
                    <div />
                    <div />
                  </div>
                </div>
              </div>
              <hr class="w-50">
            </div>

            <div v-else>
              <h3>{{ __('Faça a leitura do código abaixo e aguarde') }}!</h3>
              <hr class="w-50">
              <div v-html="qrcode" />
              <hr class="w-50">
            </div>
          </div>

          <div
            class="text-center"
            v-else
          >
            <h3>{{ __('Por favor, pegue seu dispositivo e abra o WhatsApp') }}.</h3>
            <hr class="w-50">
            <div class="text-center">
              <p>
                <video
                  autoplay="autoplay"
                  controls="controls"
                  muted="muted"
                  loop="loop"
                  src="/build/images/app/scanqr.mp4"
                  width="540"
                />
              </p>
            </div>
            <hr class="w-50">
            <button
              class="btn btn-lg btn-success my-4"
              @click.prevent="getQrCode"
            >
              {{ __('Estou pronto, vamos fazer') }}<i class="fa fa-arrow-right ml-2" />
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      qrcode: null,
      device: null,
      loading: true,
      scanning: false,
    };
  },

  mounted () {
    Bus.$on('authorizingScanDevice', (device) => {
      this.device = device;
    });
  },

  methods: {
    getQrCode () {
      this.scanning = true;
      this.loading = true;

      this.$http.post('/device/scan', this.device)
        .then((response) => {
          this.qrcode = response.data;
          this.loading = false;

          this.device.force = false;
          setTimeout(() => this.getQrCode(), 30000);
        })
        .catch(({ data: error }) => {
          console.log(`${error.status}: ${error.message}`);

          this.device.force = false;

          switch (error.status) {
            case 404:
            case 500:
              Alert.error(this.__('Ops, não foi possível carregar o QR Code, tente novamente em instantes.'));

              // this.cancel();

              setTimeout(() => this.getQrCode(), 10000);
              break;
            case 409:
              this.getStatus();
              break;
            case 429:
              const delay = error.message.slice(61, -9) * 3000;
              setTimeout(() => this.getQrCode(), delay);
              break;
            default:
              setTimeout(() => this.getQrCode(), 10000);
              break;
          }
        });
    },

    getStatus () {
      this.$http.post('/device/status', this.device)
        .then(({ data: session }) => {
          if (session.status === 'online') {
            Bus.$emit('refreshDevice', this.device);

            this.cancel();

            return;
          }

          setTimeout(() => this.getQrCode(), 10000);
        })
        .catch(({ data: error }) => {
          console.log(`${error.status}: ${error.message}`);

          this.getStatus();
        });
    },

    cancel () {
      this.device = null;
      this.scanning = false;

      Bus.$emit('scanningButtonToggle');
    },
  },
};
</script>
